import React from 'react'
import NavLink from '../Routes/NavLink'

import BuildingCard from '../Building/BuildingCard.jsx'

import { buildings } from '../../core/controllers/Buildings'

export default class BuildingLastEditedWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        };
    }

    componentDidMount() {
        var self = this;
        buildings.getLastEditedBuilding(function(response) {
            self.setState({
                data: response.data
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const building = this.state.data;
        var buildingData, buildingDetails, buildingMetaData;
        if(building) {
            buildingDetails = building.data;
            buildingData = building.belongsTo;
            buildingMetaData = building.meta_data;
        }

        return (
            <div>
                {building != null ? (
                    <BuildingCard key={buildingData.building_id} buildingDetails={buildingDetails} buildingData={buildingData} buildingMetaData={buildingMetaData}/>
                ) : (
                    <div class="col-md-4">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Recent Building Activity</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <p>Could not find any recent building activity.  Try adding one!</p>
                                <div class="footer">
                                    <hr/>
                                    <div class="legend">
                                        <NavLink to={"/building/new"}>
                                        <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" >
                                        Add Building
                                        </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                }
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingLastEditedWidget.jsx